<p-card header="Baixar arquivo de indicador">
  <div class="p-fluid">
    <div class="p-formgrid p-grid" *ngIf="endereco">

      <div class="p-col-12 p-lg-9" *ngIf="url">
        Arquivo:
        <a [href]="url" class="p-link" style="word-break: break-all;">{{endereco}}</a>
      </div>
      <div class="p-col-12 p-lg-9" *ngIf="erro">
        {{erro}}
      </div>
      <div class="p-col-12 p-lg-9" *ngIf="carregando">
        <em class="pi-fw pi pi-spin pi-spinner"></em><br>
        Carregando o arquivo: {{endereco}}...
      </div>
    </div>
    <div class="p-formgrid p-grid" *ngIf="!endereco">
      <div class="p-col-12 p-lg-12">
        Nenhum endereço de arquivo foi informado!
      </div>
    </div>
  </div>
</p-card>
